module.exports = __webpack_public_path__ + "img/logo-yslab.00c4515c.svg";